module.exports = __webpack_public_path__ + "img/grosse-aiguille.c701d73b.png";